import React from "react";
import DHSplashScreen from "../../component/DHSplashScreen";
import Footer from "../../component/Footer";
import DefaultButton from "../../component/DefaultButton";
import SwitchTabs from "../../component/SwitchTab";
import ErrorComponent from "../../component/ErrorComponent";
import smartphone_line from "../../images/smartphone-line.svg";
import email_line from "../../images/mail-line.svg";
import India_flag from "../../images/india-logo.png";
import DH_Logo from "../../images/dh-logo-min-1.svg";
import SocialLogin from "../../component/SocialLogin";
import { createPasswordlessCode } from "supertokens-web-js/recipe/thirdpartypasswordless";
import { useNavigate } from "react-router-dom";
import {
  DECCAN_MOBILE_TAB,
  DECCAN_PRIVACY_POLICY_URL,
  DECCAN_TERMS_URL,
  EMAIL_REGEX,
  GENERAL_ERROR_MSG,
  INFO_MSG_EMAIL,
  INFO_MSG_PHONE,
  email_tab_indetifier,
  mobile_tab_indetifier,
} from "../../contant";
import Tooltip from "../../component/Tooltip";
import { toast } from "react-toastify";

const tabsData = [
  {
    tabName: DECCAN_MOBILE_TAB,
    tabLogo: smartphone_line,
    tabIdentifier: mobile_tab_indetifier,
  },
  {
    tabName: "Email",
    tabLogo: email_line,
    tabIdentifier: email_tab_indetifier,
  },
];

export default function DeccanLoginPage({ emailRequired, phoneNumberRequired, signupMessage }) {
  const [tab, setTab] = React.useState(
    emailRequired
      ? "Email"
      : localStorage.getItem("tab_detail") === DECCAN_MOBILE_TAB ||
        localStorage.getItem("tab_detail") === "EMAIL"
        ? localStorage.getItem("tab_detail")
        : DECCAN_MOBILE_TAB
  );
  const [inputError, setInputError] = React.useState(null);
  const [isInputFocused, setIsInputFocused] = React.useState(false);
  const [formData, setFormData] = React.useState({
    email: "",
    phone: "",
  });
  const [isDisableButton, setIsDisableButton] = React.useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    let { name, value } = e.target;
    // Sanitize the value if the input name is 'phone'
    if (name === "phone") {
      value = value.replace(/\D/g, "");
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setInputError("");
  };
  async function sendMagicLink() {
    setIsDisableButton(true);
    setIsInputFocused(false);
    const responsePayload =
      tab === DECCAN_MOBILE_TAB
        ? { phoneNumber: `+91${formData.phone}` }
        : { email: formData.email };
    const errMsg =
      tab === DECCAN_MOBILE_TAB ? "Invalid phone number" : "Invalid email";
    const infoMsg = tab === DECCAN_MOBILE_TAB ? INFO_MSG_PHONE : INFO_MSG_EMAIL;
    if (formData.email && !EMAIL_REGEX.test(formData.email)) {
      setInputError(errMsg);
      setIsDisableButton(false);
      return;
    }
    if (formData.phone || formData.email) {
      try {
        let response = await createPasswordlessCode(responsePayload);
        if (response.status === "SIGN_IN_UP_NOT_ALLOWED") {
          // this can happen due to automatic account linking. See that section in our docs.
        } else {
          // Magic link sent successfully.
          toast.info(infoMsg);
          navigate("/auth/verify_otp");
          localStorage.setItem("user_login_detail", JSON.stringify(formData));
          localStorage.setItem("tab_detail", tab);
        }
      } catch (err) {
        console.log("errormsg", err);
        if (err.isSuperTokensGeneralError === true) {
          // this may be a custom error message sent from the API by you,
          // or if the input email / phone number is not valid.
          setInputError(errMsg);
        } else {
          toast.error(GENERAL_ERROR_MSG);
        }
      } finally {
        setIsDisableButton(false);
      }
    } else {
      setInputError(errMsg);
      setIsDisableButton(false);
    }
  }

  return (
    <div className="lg:h-full xxxl:h-screen xxxl:flex xxxl:flex-row xxxl:items-center xxxl:justify-center short-screen-spacing">
      <div className="flex flex-row w-full text-center justify-center lg:pt-8 px-10 md:p-1 xxxl:pt-0 sm:min-h-mobile">
        <DHSplashScreen logoImage={DH_Logo} />
        <div className="w-1/2 shadow-md rounded-2xl bg-white ml-2 pt-4 sm:w-full sm:ml-0 sm:flex sm:flex-col sm:justify-between">
          <div className="lg:px-4 w-full">
            <p className="text-gray-900 font-bold mb-6 text-[28px]">
              Log in or Create Your Account
            </p>
            <fieldset disabled={isDisableButton} className="contents w-full">
              <form className="w-full" onSubmit={(e) => e.preventDefault()}>
                {!phoneNumberRequired && !emailRequired ? <div className="w-full flex justify-center">
                  <SwitchTabs
                    data={tabsData}
                    setTab={setTab}
                    tab={tab}
                    setInputError={setInputError}
                    className={"font-notoSerif"}
                  />
                </div> : signupMessage ?
                  <p className="text-base text-[#999999] max-w-[23rem] mx-auto -mb-10 mt-16">{signupMessage}</p>
                  : <div className="mt-10"></div>}
                <div className="w-full flex justify-center items-center lg:px-9 md:px-0 sm:px-2">
                  {inputError ? (
                    <>
                      {(tab === DECCAN_MOBILE_TAB && formData.phone === "") ||
                        (tab === "Email" && formData.email === "") ? (
                        <Tooltip />
                      ) : (
                        <ErrorComponent
                          errorMsg={inputError}
                          onClick={() => setInputError("")}
                          className={
                            "w-[55%] lg:w-full md:w-full sm:w-full xs:w-full"
                          }
                        />
                      )}
                    </>
                  ) : (
                    <div className="mt-16"></div>
                  )}
                </div>
                {tab === DECCAN_MOBILE_TAB ? (
                  <div className="w-full flex justify-center items-center lg:px-9 md:px-0 sm:px-2">
                    <div
                      className="flex justify-center items-center w-3/5 sm:w-full md:w-full"
                      style={{ paddingBottom: "0.5px" }}
                    >
                      <button
                        className={`flex items-center gap-1 text-base text-gray-500 px-4 py-2 border border-solid border-gray-300 border-r-0 pointer-events-none shadow-sm rounded-md rounded-r-none focus:outline-none focus:border-[#087E9E] focus:ring-1 focus:ring-[#087E9E] ${
                          (inputError || isInputFocused) &&
                          "!border-[#087E9E] focus:border-[#087E9E] focus:ring-[#087E9E]"
                          }`}
                        type="button"
                      >
                        <img
                          src={India_flag}
                          alt="flag"
                          className="items-center max-w-8 h-auto"
                        />{" "}
                        +91
                      </button>
                      <input
                        type="tel"
                        name="phone"
                        id="phone"
                        maxLength={10}
                        className={`w-[73%] lg:w-full md:w-full sm:w-full xs:w-full text-base text-gray-500 pl-3.5 sm:pl-1.5 pr-9 sm:pr-2 py-3 pt-[13px] border border-solid border-gray-300 border-l-0 focus:outline-none focus:border-[#087E9E] focus:ring-1 focus:ring-[#087E9E] shadow-sm rounded-md rounded-l-none ${
                          inputError &&
                          "!border-[#087E9E] focus:border-[#087E9E] focus:ring-[#087E9E]"
                          }`}
                        placeholder="Enter phone number"
                        value={formData.phone}
                        onChange={handleChange}
                        onFocus={() => {
                          setIsInputFocused(true);
                        }}
                        onBlur={() => {
                          setIsInputFocused(false);
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="w-full flex justify-center items-center lg:px-9 md:px-0 sm:px-2">
                    <input
                      type="email"
                      name="email"
                      id="email"
                      className={`w-[55%] lg:w-full md:w-full sm:w-full xs:w-full text-base text-gray-500 pl-3.5 pr-2 pb-3 pt-[13px] border border-solid border-gray-300 tracking-[0px] leading-6 focus:outline-none focus:border-[#087E9E] focus:ring-1 focus:ring-[#087E9E] shadow-sm rounded-md ${
                        inputError &&
                        "!border-[#087E9E] focus:border-[#087E9E] focus:ring-[#087E9E]"
                        }`}
                      placeholder="Enter email id"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                )}
                <div className="w-full flex justify-center items-center mb-8 mt-4 lg:px-9 md:px-0 sm:px-2">
                  <DefaultButton
                    label={"Continue"}
                    onClick={sendMagicLink}
                    disabled={isDisableButton}
                    className={
                      "w-[55%] lg:w-full md:w-full sm:w-full xs:w-full"
                    }
                    type={"submit"}
                  />
                </div>
              </form>
              {!phoneNumberRequired ?<>
                <div className="flex justify-center mb-1 xs:px-2">
                  <div className="w-[55%] flex flex-row justify-between lg:w-10/12 md:w-full">
                    <div className="w-1/4 pr-2 pt-2.5">
                      <div className="divider-clr-section border-t"></div>
                    </div>
                    <p className="w-1/2 text-[#999] font-medium">
                      Or Continue With
                    </p>
                    <div className="w-1/4 pl-2 pt-2.5">
                      <div className="divider-clr-section border-t"></div>
                    </div>
                  </div>
                </div>
                <SocialLogin setIsDisableButton={setIsDisableButton} />
              </> : <div className="mt-28"></div>}
              <div className="w-full flex justify-center mt-10 mb-4">
                <div className="w-2/3 text-sm font-normal align-center item center text-[#999] px-12 leading-6 lg:w-full">
                  By signing in or creating an account, you agree with our{" "}
                  <a
                    className={`font-roboto text-[#00A7EF] underline cursor-pointer font-bold ${
                      isDisableButton && "pointer-events-none"
                      }`}
                    href={DECCAN_TERMS_URL}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Terms & Conditions
                  </a>{" "}
                  and{" "}
                  <a
                    className={`font-roboto text-[#00A7EF] underline cursor-pointer font-bold  ${
                      isDisableButton && "pointer-events-none"
                      }`}
                    href={DECCAN_PRIVACY_POLICY_URL}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Privacy Policy.
                  </a>
                </div>
              </div>
            </fieldset>
          </div>
          <Footer footerLable={"Your Login, Simplified"} />
        </div>
      </div>
    </div>
  );
}
